import { combineReducers } from 'redux';
import session from './modules/session/session-reducers';
import help from './modules/help/help-reducers';
import uiLayout from './modules/layout/uilayout-reducers';
import profile from './modules/profile/profile-reducers';
import settings from './modules/settings/settings-reducer';
import dashboard from './modules/dashboard/dashboard-reducer';
import extensions from './modules/extensions/extensions-reducer';
import log from './redux/reducers/log-reducer';
import update from './modules/update/update-reducers';

const coreReducers = {
  session,
  help,
  uiLayout,
  log,
  settings,
  extensions,
  update,
};

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...coreReducers,
    ...asyncReducers
  });
};


// export default appReducer;
export default createReducer;